import React from 'react';
import axios from 'axios';

import Loading from '../Loading';

import styles from '../../styles/DynamicModal.module.css';

import IconContainer from '../IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

const AddNewLPP = ({ closeModal, id, type, action, onDoSuccess }) => {
    const [categoryInfo, setCategoryInfo] = React.useState({
        name: '',
    });
    const [procedureInfo, setProcedureInfo] = React.useState({
        name: '',
    });
    const [phaseInfo, setPhaseInfo] = React.useState({
        order_of_phase: '',
        name: '',
        time: '',
        typesch: ''
    });
    const [loading, setLoading] = React.useState(true);
    const [status, setStatus] = React.useState(null);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            if (type=='category') {
                axios.get(`/api/category?id=${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => {
                    setCategoryInfo(response.data);
                    setStatus(null);
                }).catch((error) => {
                    console.error(error);
                    setStatus(<a className='mainLabelError'>Не удалось загрузить данные категории. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
                }).finally(() => {
                    setLoading(false);
                })
            }
            if (type=='procedure') {
                axios.get(`/api/procedure?id=${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => {
                    setProcedureInfo(response.data);
                    setStatus(null);
                }).catch((error) => {
                    console.error(error);
                    setStatus(<a className='mainLabelError'>Не удалось загрузить данные процедуры. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
                }).finally(() => {
                    setLoading(false);
                })
            }
            if (type=='phase') {
                axios.get(`/api/phase?id=${id}`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => {
                    setPhaseInfo(response.data);
                    setStatus(null);
                }).catch((error) => {
                    console.error(error);
                    setStatus(<a className='mainLabelError'>Не удалось загрузить данные этапа исполнения. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
                }).finally(() => {
                    setLoading(false);
                })
            }
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        if (type=='category') {
            setCategoryInfo((prev) => ({ ...prev, [field]: value }));
        }
        if (type=='procedure') {
            setProcedureInfo((prev) => ({ ...prev, [field]: value }));
        }
        if (type=='phase') {
            setPhaseInfo((prev) => ({ ...prev, [field]: value }));
        }
        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (type=='category') {
            if (!categoryInfo.name) {
                newErrors.name = 'Обязательное поле';
            }
            if (categoryInfo.name && (categoryInfo.name.length < 2 || categoryInfo.name.length > 50)) {
                newErrors.name = 'Значение не может быть меньше 2 и более 50 символов';
            }
        }
        if (type=='procedure') {
            if (!procedureInfo.name) {
                newErrors.name = 'Обязательное поле';
            }
            if (procedureInfo.name && (procedureInfo.name.length < 2 || procedureInfo.name.length > 50)) {
                newErrors.name = 'Значение не может быть меньше 2 и более 50 символов';
            }
        }
        if (type=='phase') {
            if (!phaseInfo.order_of_phase) {
                newErrors.order_of_phase = 'Обязательное поле';
            }
            if (phaseInfo.order_of_phase && phaseInfo.order_of_phase < 1) {
                newErrors.order_of_phase = 'Значение не может быть отрицательным или равным 0';
            }
            if (phaseInfo.order_of_phase?.length > 3) {
                newErrors.order_of_phase = 'Значение не может быть более 3 символов';
            }
            if (!phaseInfo.name) {
                newErrors.name = 'Обязательное поле';
            }
            if (phaseInfo.name?.length < 2 || phaseInfo.name.length > 50) {
                newErrors.name = 'Значение не может быть меньше 2 и более 50 символов';
            }
            if (!phaseInfo.time) {
                newErrors.name = 'Обязательное поле';
            }
            if (phaseInfo.time && phaseInfo.time < 1) {
                newErrors.time = 'Значение не может быть отрицательным или равным 0';
            }
            if (phaseInfo.time?.length > 3) {
                newErrors.time = 'Значение не может быть более 3 символов';
            }
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        if (type=='category') {
            axios.post('/api/add-new-category', {
                id: id,
                name: categoryInfo.name,
            })
            .then(() => {
                setStatus('Категория добавлена');
                onDoSuccess();
            })
            .catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        }
        if (type=='procedure') {
            axios.post('/api/add-new-procedure', {
                id: id,
                name: procedureInfo.name,
            })
            .then(() => {
                setStatus('Процедура добавлена');
                onDoSuccess();
            })
            .catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        }
        if (type=='phase') {
            axios.post('/api/add-new-phase', {
                id: id,
                order_of_phase: phaseInfo.order_of_phase,
                name: phaseInfo.name,
                time: phaseInfo.time,
                typesch: phaseInfo.typesch,
            })
            .then(() => {
                setStatus('Этап добавлен');
                onDoSuccess();
            })
            .catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    const changeData = () => {
        if (type=='category') {
            axios.put(`/api/change-category`, {
                id: categoryInfo.id,
                name: categoryInfo.name,
            }).then(() => {
                setStatus('Данные категории изменены');
                onDoSuccess();
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        }
        if (type=='procedure') {
            axios.put(`/api/change-procedure`, {
                id: procedureInfo.id,
                name: procedureInfo.name,
            }).then(() => {
                setStatus('Данные категории изменены');
                onDoSuccess();
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        }
        if (type=='phase') {
            axios.put(`/api/change-phase`, {
                id: phaseInfo.id,
                order_of_phase: phaseInfo.order_of_phase,
                name: phaseInfo.name,
                time: phaseInfo.time,
                typesch: phaseInfo.typesch,
            }).then(() => {
                setStatus('Данные этапа изменены');
                onDoSuccess();
            }).catch((error) => {
                setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        }
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    }


    return (
        <div className={styles.liningOver} onClick={closeModal}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;{type=='category' && 'категории'}{type=='procedure' && 'процедуры'}{type=='phase' && 'этапа'}
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    {type=='category' &&
                    <>
                        <div className='labelInputWrapper'>
                            <a className='label'>Название категории</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='text' 
                                    value={categoryInfo.name} 
                                    onChange={handleChange('name')} 
                                    className={errorsForm.name ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='50' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                                </div>
                            </div>
                        </div>
                    </>}
                    {type=='procedure' &&
                    <>
                        <div className='labelInputWrapper'>
                            <a className='label'>Название процедуры</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='text' 
                                    value={procedureInfo.name} 
                                    onChange={handleChange('name')} 
                                    className={errorsForm.name ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='50' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                                </div>
                            </div>
                        </div>
                    </>}
                    {type=='phase' &&
                    <>
                        <div className='labelInputWrapper'>
                            <a className='label'>Порядок этапа</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='number' 
                                    value={phaseInfo.order_of_phase} 
                                    onChange={handleChange('order_of_phase')} 
                                    className={errorsForm.order_of_phase ? 'inputError' : ''}
                                    inputMode='numeric' 
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='3' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.order_of_phase && <div className='errorUnderInput'>{errorsForm.order_of_phase}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='labelInputWrapper'>
                            <a className='label'>Название этапа</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='text' 
                                    value={phaseInfo.name} 
                                    onChange={handleChange('name')} 
                                    className={errorsForm.name ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='200' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.name && <div className='errorUnderInput'>{errorsForm.name}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='labelInputWrapper'>
                            <a className='label'>Срок исполнения этапа</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='number' 
                                    value={phaseInfo.time} 
                                    onChange={handleChange('time')} 
                                    className={errorsForm.time ? 'inputError' : ''}
                                    inputMode='numeric' 
                                    placeholder='Количество в днях' 
                                    minLength='' 
                                    maxLength='3' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.time && <div className='errorUnderInput'>{errorsForm.time}</div>}
                                </div>
                                <label className='legCheckboxWrapper'>
                                    <input 
                                        type='checkbox'
                                        checked={phaseInfo.typesch}
                                        onChange={handleChange('typesch')} 
                                    />
                                    <a>Срок отсчитывается только по рабочим дням</a>
                                </label>
                            </div>
                        </div>
                    </>}
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
};

export default AddNewLPP;
